var exports = {
  "aN": "GuildSettingsModal.module__sidebarHeader___c0s5ak",
  "J5": "GuildSettingsModal.module__guildName___c0s5ak",
  "YO": "GuildSettingsModal.module__channelNameWithIcon___c0s5ak",
  "er": "GuildSettingsModal.module__channelNameIcon___c0s5ak",
  "Kw": "GuildSettingsModal.module__channelNameText___c0s5ak",
  "i7": "GuildSettingsModal.module__sidebarButtonWrapper___c0s5ak",
  "cy": "GuildSettingsModal.module__sidebarButtonIcon___c0s5ak",
};

module.exports = exports;
